export class GenericPopupType {
    public static readonly FREESPIN_INTRO: symbol = Symbol('FREESPIN_INTRO');
    public static readonly FREESPIN_OUTRO: symbol = Symbol('FREESPIN_OUTRO');
    public static readonly FREESPIN_OUTRO_NO_WIN: symbol = Symbol('FREESPIN_OUTRO_NO_WIN');
    public static readonly FREESPIN_RETRIGGER: symbol = Symbol('FREESPIN_RETRIGGER');
    public static readonly RESPIN_INTRO: symbol = Symbol('RESPIN_INTRO');
    public static readonly RESPIN_OUTRO: symbol = Symbol('RESPIN_OUTRO');

    public static readonly JACKPOT_GRAND: symbol = Symbol('JACKPOT_GRAND');
    public static readonly JACKPOT_MAJOR: symbol = Symbol('JACKPOT_MAJOR');
    public static readonly JACKPOT_MINOR: symbol = Symbol('JACKPOT_MINOR');
    public static readonly JACKPOT_MINI: symbol = Symbol('JACKPOT_MINI');
}